import React from "react"
import { Container } from "./RelatedLinks.styles"
import Button from "../Button/Button"
import Download from "../../images/icon-download.svg"

const RelatedLinks = links => {
  const data = links.links

  const linksButtons = data.map(link => (
    <Button
      key={link.acf_link.link}
      label={link.title}
      iconRight={Download}
      externalLink={link.acf_link.link}
    ></Button>
  ))
  return <Container>{linksButtons}</Container>
}

export default RelatedLinks
